import { NgModule } from '@angular/core';
import { PriceModule } from '@icc/price';
import { PriceMosquitoService } from './price-mosquito.service';

@NgModule({
    imports: [PriceModule],
    providers: [PriceMosquitoService],
})
export class MosquitoPriceModule {}
